import { render, staticRenderFns } from "./addannouncement.vue?vue&type=template&id=512b3c82&scoped=true"
import script from "./addannouncement.vue?vue&type=script&lang=js"
export * from "./addannouncement.vue?vue&type=script&lang=js"
import style0 from "./addannouncement.vue?vue&type=style&index=0&id=512b3c82&prod&scoped=true&lang=css"
import style1 from "./addannouncement.vue?vue&type=style&index=1&id=512b3c82&prod&scoped=true&lang=css"
import style2 from "./addannouncement.vue?vue&type=style&index=2&id=512b3c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b3c82",
  null
  
)

export default component.exports